import { render, staticRenderFns } from "./RedisStatus.vue?vue&type=template&id=6aa1df64&scoped=true"
import script from "./RedisStatus.vue?vue&type=script&lang=js"
export * from "./RedisStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa1df64",
  null
  
)

export default component.exports